import { useId } from 'react';

const useFormIds = <T extends readonly string[]>(fields: T): Record<T[number], string> => {
  const baseId = useId();
  return fields.reduce(
    (acc, field) => {
      acc[field as T[number]] = `${baseId}-${field}`;
      return acc;
    },
    {} as Record<T[number], string>,
  );
};

export default useFormIds;
